// eslint-disable-next-line import/prefer-default-export
export const skusSelector = (state) => state.getIn(['entities', 'skus']).toJS();
